import React from 'react';
import { Offer as OfferType } from '@model/iceberg/hotel-content/hotel-content';
import { TestId } from '@components/test-ids';
import { ExpandableListGroupItem } from '@model/common';
import { Icon } from '@components/common/generic-icon';
import { Theme } from '@theme/base';
import ExpandableListWrapper from '@components/material-ui/expandable-list-item/ExpandableListWrapper';

export interface SpecialOfferProps {
  specialOffer: Array<OfferType>;
  heading: string;
  testId?: string;
  theme?: Theme;
  iconSize?: number;
}

export const SpecialOffer = (props: SpecialOfferProps) => {
  const { specialOffer, testId, heading, theme, iconSize = 20 } = props;
  const starStyling = {
    fontSize: iconSize,
    marginRight: theme?.custom.spacing.small,
    transition: `color ${theme?.custom.transitions.default}`,
    color: theme?.custom.colors.group1.base,

    ['&hover']: {
      color: theme?.custom.colors.group2.base
    }
  };

  const items: Array<ExpandableListGroupItem> = Object.entries(specialOffer).map(([key, value]: any) => ({
    title: value.name,
    text: { description: value.description, terms: value.terms },
    icon: <Icon key={key} name={'mhi-star'} css={{ ...starStyling }} />
  }));

  return <ExpandableListWrapper items={items} heading={heading} testId={testId || TestId.specialOffers.main} />;
};
